<template>
  <div class="w-full">
    <button
      data-test="button_general"
      class="relative flex items-center gap-5 transition-colors text-gray-30 enabled:hover:bg-gray-98 rounded-xl border border-gray-84 py-3.5 pl-6 pr-4 w-full"
      :class="{ 'bg-gray-94 text-gray-70 pointer-events-none': disabled }"
      tabindex="0"
      @click="modalOpened = true"
    >
      <div class="w-full text-sm text-left truncate mt-0.5">
        {{ selectedOption?.displayText ?? selectedOption?.value }}
      </div>
      <IconsAngleUpDown class="h-4 aspect-square transition-transform text-dlubal-blue" />
    </button>
    <UModal
      v-if="options.length > 0"
      :opened="modalOpened"
      @close="modalOpened = false"
    >
      <ul
        data-test="button_ul"
        class="flex flex-col mt-3 mb-6 mx-2 gap-y-1"
      >
        <template
          v-for="option in options"
          :key="option.value"
        >
          <li
            v-if="!option.hidden"
            class="select-opt text-gray-30 px-4 pt-[9px] pb-2 truncate text-sm rounded-lg transition-colors duration-100 ease-in-out"
            :class="{
              'bg-gray-96': selectedOption?.value === option.value,
              'bg-gray-84': option.disabled,
              ' hover:bg-gray-96 cursor-pointer': !option.disabled
            }"
            @click="
              () => {
                if (option.disabled) {
                  return
                }

                handleClick(option.value!)
                modalOpened = false
              }
            "
          >
            {{ option.displayText ?? option.value }}
          </li>
        </template>
      </ul>
    </UModal>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import UModal from './UModal.vue'

export interface UComboboxOption {
  selected: boolean
  disabled?: boolean
  hidden?: boolean
  value: string | number
  displayText?: string
}

export interface UComboboxProps {
  disabled?: boolean
  openOnMount?: boolean
  options: Array<UComboboxOption>
}

const props = withDefaults(defineProps<UComboboxProps>(), {
  disabled: false,
  openOnMount: false
})

interface Emits {
  (e: 'click', value: string | number): void
}

const emit = defineEmits<Emits>()

const selectedOption = computed(() => props.options.find(item => item.selected))

const handleClick = (value: string | number) => {
  emit('click', value)
}

const modalOpened = ref<boolean>(false)
</script>
